module.exports = __webpack_public_path__ + "static/artist-contract-self-managed-2018-6586b94661e5ce0a19982d4811c92f05.pdf";